function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cart_stroke{fill:none;stroke:currentColor;stroke-width:2;stroke-miterlimit:10;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "cart"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cart_fill",
  points: "9.45 7.77 60.36 7.77 60.36 25.24 17.23 36.8 9.45 7.77"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cart_fill",
  cx: 7.52,
  cy: 55.05,
  r: 3.64
}), /*#__PURE__*/React.createElement("circle", {
  className: "cart_fill",
  cx: 60.36,
  cy: 55.05,
  r: 3.64
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cart_stroke",
  points: "9.45 7.77 60.36 7.77 60.36 25.24 17.23 36.8 7.51 .5 0 .5"
}), /*#__PURE__*/React.createElement("line", {
  className: "cart_stroke",
  x1: 60.36,
  y1: 51.41,
  x2: 7.52,
  y2: 51.41
}), /*#__PURE__*/React.createElement("circle", {
  className: "cart_stroke",
  cx: 7.52,
  cy: 55.05,
  r: 3.64
}), /*#__PURE__*/React.createElement("circle", {
  className: "cart_stroke",
  cx: 60.36,
  cy: 55.05,
  r: 3.64
}), /*#__PURE__*/React.createElement("line", {
  className: "cart_stroke",
  x1: 17.23,
  y1: 36.8,
  x2: 9.45,
  y2: 51.41
}));

var SvgCart = function SvgCart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cartIcon",
    viewBox: "-2 -2 68.5 63.18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cart.d2a7d38e.svg";
export { ForwardRef as ReactComponent };